<template>
  <v-card class="elevation-12">
    <v-toolbar color="primary" dark flat>
      <v-toolbar-title> Новый договор</v-toolbar-title>
      <v-spacer/>
    </v-toolbar>

    <v-alert v-if="sendContractApprove && sendContractApprove.comments" border="bottom" colored-border type="warning" elevation="2">
      <div v-html="sendContractApprove.comments"></div>
    </v-alert>
    <v-alert v-if="(sendContractApprove && sendContractApprove.contract_initiator) || (sendContractApprove && sendContractApprove.contract_product_group)"
             border="bottom"
             colored-border
             type="info"
             elevation="2"
    >
      <div>
        <p class="mb-0"><b>Инициатор контракта:</b> {{sendContractApprove.contract_initiator}}</p>
        <p class="mb-0"><b>Контрактная группа продуктов:</b> {{sendContractApprove.contract_product_group}}</p>
      </div>
    </v-alert>

    <v-expansion-panels v-model="panels" :multiple="true" focusable accordion>
      <v-expansion-panel>
        <v-expansion-panel-header>Данные договора</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col cols="12" sm="6" md="4" lg="3" class="pa-0 py-2 px-2">
              <v-text-field v-model="form.number" label="Номер" :hide-details="true" :error="$v.form.number.$error"/>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" class="pa-0 py-2 px-2">
              <DateInput v-model="form.date" label="Дата" :hide-details="true" :error="$v.form.date.$error" :max="now"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="4" lg="3" class="pa-0 py-2 px-2">
              <v-text-field v-model="form.title" label="Наименование" :hide-details="true" :disabled="!!(sendContractApprove && sendContractApprove.name)" :error="$v.form.title.$error"/>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" class="pa-0 py-2 px-2">
              <DateInput v-model="form.expiresOn" label="Действителен до" :hide-details="true" :error="$v.form.expiresOn.$error" :min="form.date"/>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" class="pa-0 py-2 px-2">
              <v-text-field v-model="form.place" label="Место заключения" :hide-details="true" :error="$v.form.place.$error"/>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header>Реквизиты сторон</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col lg="6" cols="12">
              <h3>
                Заказчик
                <v-dialog v-model="form.customer.dialog" persistent max-width="720px">
                  <v-card>
                    <v-card-title> Выбор заказчика</v-card-title>

                    <v-card-text>
                      <select-company v-model="form.customer.company" @change="onCustomerCompanyChanged"/>
                    </v-card-text>

                    <v-card-actions>
                      <v-btn color="secondary" @click="form.customer.dialog = false">Закрыть</v-btn>
                    </v-card-actions>
                  </v-card>
                  <template v-slot:activator="{on}">
                    <v-btn v-on="on" color="primary" small text :disabled="!!sendContractApprove"> Выбрать</v-btn>
                  </template>
                </v-dialog>
              </h3>
              <b :class="{'red--text': $v.form.customer.name.$error}">Наименование</b>: {{ form.customer.name }}
              <br/>
              <b :class="{'red--text': $v.form.customer.inn.$error}">Инн</b>: {{ form.customer.inn }}
              <v-text-field v-model="form.customer.directorInn" :dense="true" :hide-details="true"
                            placeholder="Инн директора" :error="$v.form.customer.directorInn.$error"/>
              <v-text-field v-model="form.customer.directorName" :dense="true" :hide-details="true"
                            placeholder="Директор" :error="$v.form.customer.directorName.$error"
                            :disabled="!!this.sendContractApprove && !!this.sendContractApprove.customer_director"
              />
              <v-text-field v-model="form.customer.phone" :dense="true" :hide-details="true" placeholder="Телефон"/>
              <v-text-field v-model="form.customer.mobile" :dense="true" :hide-details="true" placeholder="Мобильный"/>
              <v-text-field v-model="form.customer.address" :dense="true" :hide-details="true" placeholder="Адрес"
                            :error="$v.form.customer.address.$error"/>
              <v-text-field v-model="form.customer.bankAccount" :dense="true" :hide-details="true"
                            placeholder="Банковский счёт" :error="$v.form.customer.bankAccount.$error"/>
              <v-text-field v-model="form.customer.bankMfo" :dense="true" :hide-details="true" placeholder="Код банка"
                            :error="$v.form.customer.bankMfo.$error"/>
              <v-text-field v-model="form.customer.bankName" :dense="true" :hide-details="true" placeholder="Банк"
                            :error="$v.form.customer.bankName.$error"/>
            </v-col>
            <v-col lg="6" cols="12">
              <h3>Поставщик</h3>
              <b :class="{'red--text': $v.form.executor.name.$error}">Наименование</b>: {{ form.executor.name }}
              <br/>
              <b :class="{'red--text': $v.form.executor.inn.$error}">Инн</b>: {{ form.executor.inn }}
              <v-text-field v-model="form.executor.directorInn" :dense="true" :hide-details="true"
                            placeholder="Инн директора" :error="$v.form.executor.directorInn.$error"/>
              <v-text-field v-model="form.executor.directorName" :dense="true" :hide-details="true"
                            placeholder="Директор" :error="$v.form.executor.directorName.$error"/>
              <v-text-field v-model="form.executor.phone" :dense="true" :hide-details="true" placeholder="Телефон"/>
              <v-text-field v-model="form.executor.mobile" :dense="true" :hide-details="true" placeholder="Мобильный"/>
              <v-text-field v-model="form.executor.address" :dense="true" :hide-details="true" placeholder="Адрес"
                            :error="$v.form.executor.address.$error"/>
              <v-text-field v-model="form.executor.bankAccount" :dense="true" :hide-details="true"
                            placeholder="Банковский счёт" :error="$v.form.executor.bankAccount.$error"/>
              <v-text-field v-model="form.executor.bankMfo" :dense="true" :hide-details="true" placeholder="Код банка"
                            :error="$v.form.executor.bankMfo.$error"/>
              <v-text-field v-model="form.executor.bankName" :dense="true" :hide-details="true" placeholder="Банк"
                            :error="$v.form.executor.bankName.$error"/>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header>Перечень товаров и услуг</v-expansion-panel-header>
        <v-expansion-panel-content>
          <template v-if="itemsAllowed">
            <v-card 
              class="mb-2" 
              elevation="1"
            >
              <v-app-bar
                flat
                color="rgba(0, 0, 0, 0)"
              >
                <v-toolbar-title class="text-h6 black--text pl-0 pr-6">
                  Товары
                </v-toolbar-title>
                <v-text-field
                  label="Поиск товаров"
                  v-model="serachProduct"
                  :outlined="true"
                  :clearable="true"
                  append-icon="fa-search"
                  :dense="true" 
                  :hide-details="true" 
                ></v-text-field>
                <v-spacer></v-spacer>

                <v-dialog persistent v-model="excelFile.dialog" max-width="520">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="primary" icon x-small v-bind="attrs" v-on="on">
                      <v-icon>fa-file-excel</v-icon>
                    </v-btn>
                  </template>

                  <v-card>
                    <v-card-title class="text-h5">
                      Заполнение спецификации из Excel файла
                    </v-card-title>
                    <v-card-text>Пожалуйста выберите файл с данными (по шаблону ГНК).</v-card-text>
                    <v-card-text>
                      <v-file-input
                          label="Загрузить файл"
                          outlined
                          dense
                          v-model="excelFile.file"
                      />
                    </v-card-text>
                    <v-card-actions>
                      <v-btn
                          color="secondary darken-1"
                          text
                          @click="excelFile.dialog = false"
                      >
                        Закрыть
                      </v-btn>
                      <v-spacer/>
                      <v-btn
                          color="primary darken-1"
                          text
                          v-if="excelFile.file"
                          @click="onImportFromFileButtonClicked"
                      >
                        Заполнить
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-btn color="success" class="mx-2" icon x-small @click="onAddItemButtonClicked">
                  <v-icon>fa-plus</v-icon>
                </v-btn>
              </v-app-bar>
            </v-card>
            <v-card 
              v-for="(item, index) of filterProductItemsByName" 
              elevation="3"
              class="mb-3"
              :key="index"
            >
              <v-app-bar
                flat
                color="rgba(0, 0, 0, 0)"
              >
                <v-toolbar-title class="text-h6 black--text pl-0">
                  {{index +1}}. {{item.product}}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn 
                  color="error" 
                  class="mr-2" 
                  icon 
                  x-small 
                  @click="onDeleteItemButtonClicked(item)"
                  v-if="form.items.length > 1"
                >
                  <v-icon>fa-trash</v-icon>
                </v-btn>
              </v-app-bar>
              <v-card-text class="pt-0">
                <v-row no-gutters>
                  <v-col cols="5">
                    <v-text-field 
                      v-model="item.product" 
                      :dense="true" 
                      :hide-details="true" 
                      label="Наименование" 
                      :error="$v.form.items.$each[index].product.$error" 
                      outlined
                    />
                  </v-col>
                  <v-col cols="1">
                    <v-text-field 
                      v-model="item.measurement" 
                      :dense="true" 
                      :hide-details="true" 
                      label="Ед. изм."
                      :error="$v.form.items.$each[index].measurement.$error" 
                      outlined
                    />
                  </v-col>
                  <v-col cols="2">
                    <v-text-field 
                      type="number"
                      v-model="item.quantity" 
                      outlined
                      :dense="true"
                      label="Количество"
                      :hide-details="true"
                      class="right-input"
                      :error="$v.form.items.$each[index].quantity.$error" 
                      @blur="$v.form.items.$each[index].quantity.$touch()"
                    />
                  </v-col>
                  <v-col cols="2">
                    <v-text-field 
                      type="number"
                      v-model="item.price" 
                      outlined
                      :dense="true"
                      :hide-details="true"
                      label="Цена"
                      class="right-input"
                      :error="$v.form.items.$each[index].price.$error"
                      @blur="$v.form.items.$each[index].price.$touch()"
                    />
                  </v-col>
                  <v-col cols="2">
                    <v-autocomplete 
                      v-model="item.ndsRate" 
                      :items="form.ndsRateOptions" 
                      label="Ставка НДС в %"
                      :dense="true" 
                      :outlined="true"
                      :hide-details="true"
                    />
                  </v-col>
                </v-row>
                <v-divider class="my-3"></v-divider>
                <v-row no-gutters>
                  <v-col cols="2">
                    <SelectMxikProduct 
                      title="ВЫБРАТЬ ИКПУ"
                      :product-catalogs="productCatalogs"
                      :error="$v.form.items.$each[index].catalog.$error" 
                      :selected-catalog="item.catalog" 
                      :fill-height="true"
                      :small="false" 
                      :block="true"
                      :default-catalog="item.defaultCatalogCode"
                      @selected="(catalog) => onItemMxikSelected(item, catalog)"
                    />
                  </v-col>
                  <v-col cols="2">
                    <v-text-field 
                      v-model="item.barcode" 
                      :dense="true" 
                      :hide-details="true" 
                      label="Штриховой код" 
                      outlined 
                      :error="$v.form.items.$each[index].barcode.$error"
                    />
                  </v-col>
                  <v-col cols="2">
                    <v-autocomplete 
                      v-model="item.attachment_id" 
                      item-text="fileName" 
                      item-value="attachment_id" 
                      label="Выбрать сертификат"
                      :items="[{attachment_id: 0, fileName: 'Не требуется сертификат'}, ...form.attachFiles.slice(0,-1)]" 
                      :error="$v.form.items.$each[index].attachment_id.$error"
                      :dense="true" outlined 
                      :hide-details="true" 
                    />
                  </v-col>
                  <v-col cols="2">
                    <v-text-field
                      :value=" getItemTotal(item) | decimalMinorCeilTwoDigit"
                      :outlined="true"
                      :dense="true"
                      :hide-details="true"
                      readonly
                      label="Стоимость"
                    />
                  </v-col>
                  <v-col cols="2">
                    <v-text-field
                      :value="getItemNdsValue(item) | decimalMinorCeilTwoDigit"
                      :outlined="true"
                      :dense="true"
                      :hide-details="true"
                      readonly
                      label="Сумма НДС"
                    />
                  </v-col>
                  <v-col cols="2">
                    <v-text-field 
                      :value="getItemTotalWithNds(item) | decimalMinorCeilTwoDigit"
                      :outlined="true"
                      :dense="true"
                      :hide-details="true"
                      readonly
                      label="Итого"
                      class="right-input"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <v-card 
              elevation="3"
              class="mb-3 mt-5"
            >
              <v-app-bar
                flat
                color="rgba(0, 0, 0, 0)"
              >
                <v-row justify="end" no-gutters>
                  <v-col cols="3">
                    <v-toolbar-title class="text-h6 black--text pl-0">
                      Итого:
                    </v-toolbar-title>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="2">
                    <v-text-field
                      :value="totals.total | decimalMinorCeilTwoDigit"
                      :outlined="true"
                      :dense="true"
                      :hide-details="true"
                      readonly
                      label="Стоимость"
                    />
                  </v-col>
                  <v-col cols="2">
                    <v-text-field
                      :value="totals.ndsValue | decimalMinorCeilTwoDigit"
                      :outlined="true"
                      :dense="true"
                      :hide-details="true"
                      readonly
                      label="Сумма НДС"
                    />
                  </v-col>
                  <v-col cols="2">
                    <v-text-field 
                      :value="totals.totalWithNds | decimalMinorCeilTwoDigit"
                      :outlined="true"
                      :dense="true"
                      :hide-details="true"
                      readonly
                      label="Итого"
                      class="right-input"
                    />
                  </v-col>
                </v-row>
              </v-app-bar>
            </v-card>
          </template>
          <template v-else>
            <div class="text-center text-h4">В данном типе договора перечень товаров и услуг не предусмотрен</div>
          </template>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header>Пункты договора</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col cols="12" md="3" :class="{'d-none': !isAnyVisibleDynamicPlaceholder}">
              <v-card class="elevation-12">
                <v-card-title>
                  Заполните поля
                </v-card-title>
                <v-card-text>
                  <v-text-field v-for="(dynamicPlaceholder, index) in form.dynamicPlaceholders"
                                :class="{'d-none': isHiddenDynamicPlaceholder(dynamicPlaceholder)}"
                                :key="dynamicPlaceholder.key"
                                v-model="dynamicPlaceholder.value" :placeholder="dynamicPlaceholder.key"
                                @input="onDynamicPlaceholderInput"
                                :error="$v.form.dynamicPlaceholders.$each[index].value.$error"
                  />
                  Эти данные автоматически заполнятся в пунтках договора
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" :md="isAnyVisibleDynamicPlaceholder ? 9 : 12">
              <template v-for="(part, index) in form.parts">
                <v-card class="elevation-12 mb-2" :key="index">
                  <v-card-title>
                    <v-text-field v-model="part.title" placeholder="Пункт" :dense="true" :hide-details="true"
                                  :readonly="!!sendContractApprove"
                                  :error="$v.form.parts.$each[index].title.$error">
                      <template v-slot:prepend>
                        <span style="width: 20px" class="mt-1">{{ part.order }}</span>
                      </template>
                      <template v-slot:append>
                        <div>
                          <v-btn color="error" icon @click="onRemovePartButtonClicked(part)"
                                 v-if="!sendContractApprove">
                            <v-icon>fa-trash</v-icon>
                          </v-btn>
                          <v-btn color="success" icon @click="onAddPartAfterButtonClicked(part)"
                                 v-if="!sendContractApprove">
                            <v-icon>fa-plus</v-icon>
                          </v-btn>
                        </div>
                      </template>
                    </v-text-field>
                  </v-card-title>
                  <v-card-text>
                    <v-textarea v-model="part.body" placeholder="Содержание" :dense="true"
                                :readonly="!!sendContractApprove"
                                :error="$v.form.parts.$each[index].body.$error"/>
                  </v-card-text>
                </v-card>
              </template>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header>Прикрепленные файлы</v-expansion-panel-header>
        <v-expansion-panel-content class="pt-4">
          <v-row v-for="(attachFile, index) in form.attachFiles" :key="attachFile.id">
            <v-col xs="12" md="6" lg="4" xl="3">
              <v-file-input v-model="attachFile.file"
                            label="Выбрать файл"
                            dense
                            @change="onAttachFileChanged(attachFile)"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" class="pa-0 px-2">
              <DateInput 
                v-model="attachFile.expires_on" 
                label="Срок действия" 
                hint="<b>Эта поля только для сертификат</b>" 
                :error="$v.form.attachFiles.$each[index].expires_on.$error" 
                :persistentHint="true" 
                :min="now" 
              />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-card-actions>
      <v-spacer/>
      <v-btn color="primary" text @click="onSaveButtonClicked()">Сохранить</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import _ from "underscore";
import AmountText from "@/helpers/amount.text";
import {decimal, required, requiredIf} from "vuelidate/lib/validators";
import ContractService from "@/services/contract.service";
import {validationMixin} from "vuelidate";
import DateInput from "@/components/Input/DateInput";
import SelectCompany from "@/components/Select/SelectCompany";
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP} from "@/store/modules/layout/actions";
import SendContractApproveService from "@/services/send.contract.approve.service";
import ParseService from "@/services/parse.service";
import ItemCalculator from "@/helpers/item.calculator";
import Moment from "moment";
import {AGREEMENT_TYPE_EXPIRATION_DATE_CHANGE} from "@/enum/ContractAgreementType";
import SelectMxikProduct from "@/components/Select/SelectMxikProduct";
import CompanyService from "@/services/company.service";

const specialDynamicPlaceholders = {
  contractNumber: '{{contract.number}}',
  contractDate: '{{contract.date}}',
  contractExpireDate: '{{contract.expireDate}}',
  executorCompanyName: '{{executor.companyName}}',
  executorDirector: '{{executor.director}}',
  contractTotalCost: '{{contract.totalCost}}',
  contractBasedOn: '{{contract.basedOn}}'
}

export default {
  name: "EditContractView",
  mixins: [validationMixin],
  components: {
    SelectMxikProduct,
    DateInput,
    SelectCompany
  },
  data: () => ({
    productCatalogs: [],
    now: Moment(),
    contract: null,
    panels: [0, 1, 2, 3, 4],
    form: {
      number: '',
      date: null,
      title: '',
      place: '',
      expiresOn: null,
      executor: {
        inn: '',
        name: '',
        directorInn: '',
        directorName: '',
        phone: '',
        mobile: '',
        address: '',
        bankAccount: '',
        bankName: '',
        bankMfo: '',
      },
      customer: {
        inn: '',
        name: '',
        directorInn: '',
        directorName: '',
        phone: '',
        mobile: '',
        address: '',
        bankAccount: '',
        bankName: '',
        bankMfo: '',

        company: null,
        dialog: false
      },
      parts: [],
      items: [],

      ndsRateOptions: [
        {text: '15 %', value: 15},
        {text: '0 %', value: 0},
        {text: 'Без ндс', value: null}
      ],
      dynamicPlaceholders: [],
      attachFiles: [],
    },
    sendContractApprove: null,
    serachProduct: "",
    excelFile: {
      dialog: false,
      file: null
    }
  }),
  computed: {
    totals() {
      let total = 0;
      let ndsValue = 0;
      let totalWithNds = 0;

      _.each(this.form.items, (item) => {
        total += this.getItemTotal(item);
        ndsValue += this.getItemNdsValue(item);
        totalWithNds += this.getItemTotalWithNds(item);
      });
      const totalWithNdsInWords = AmountText.getText(totalWithNds)
      return {total, ndsValue, totalWithNds, totalWithNdsInWords};
    },
    isAnyVisibleDynamicPlaceholder() {
      return this.form.dynamicPlaceholders.filter(dp => {
        return !this.isHiddenDynamicPlaceholder(dp)
      }).length !== 0
    },
    itemsAllowed() {
      if (this.sendContractApprove && this.sendContractApprove)
        if (typeof (this.sendContractApprove.agreement_type) === 'number')
          if (this.sendContractApprove.agreement_type === AGREEMENT_TYPE_EXPIRATION_DATE_CHANGE)
            return false

      return true
    },
    filterProductItemsByName() {
      let text = this.serachProduct !== null ? this.serachProduct.toLowerCase().trim().split(" ") : ""
      if(text.length) {
        let filteredItems = this.form.items.filter((item) => {
          let productsName = item.product.toLowerCase().trim().split(" ")
          return text.every(piece => {
            return (productsName.filter(productName => productName.includes(piece))).length
          })
        })
        return filteredItems
      }
      return this.form.items
    }
  },
  validations: {
    form: {
      title: {
        required
      },
      number: {
        required
      },
      date: {
        required,
        allow() {
          if (this.form.date)
            if (this.form.date.isBefore(this.now, 'date') || (this.form.date.format('YYYY-MM-DD') === this.now.format('YYYY-MM-DD')))
              return true

          return false
        }
      },
      place: {
        required
      },
      expiresOn: {
        required,
        allow() {
          if (this.form.date)
            if (this.form.expiresOn)
              if (
                  this.form.date.isBefore(this.form.expiresOn, 'date') ||
                  (this.form.date.format('YYYY-MM-DD') === this.form.expiresOn.format('YYYY-MM-DD'))
              )
                return true

          return false
        }
      },
      executor: {
        inn: {
          required
        },
        name: {
          required
        },
        directorInn: {
          required
        },
        directorName: {
          required
        },
        address: {
          required
        },
        bankAccount: {
          required
        },
        bankMfo: {
          required
        },
        bankName: {
          required
        },
      },
      customer: {
        inn: {
          required
        },
        name: {
          required
        },
        directorInn: {
          required
        },
        directorName: {
          required
        },
        address: {
          required
        },
        bankAccount: {
          required
        },
        bankMfo: {
          required
        },
        bankName: {
          required
        },
      },
      parts: {
        $each: {
          title: {
            required
          },
          body: {
            required
          },
          order: {
            required
          }
        },
      },
      items: {
        $each: {
          barcode: {
            format(value) {
              if (value) {
                return /^\d{1,13}$/.test(value)
              }
              return true
            }
          },
          measurement: {
            required
          },
          product: {
            required,
          },
          quantity: {
            required,
            decimal,
            range(quantity) {
              return quantity >= 0
            },
          },
          price: {
            required,
            decimal,
            range(price) {
              return price >= 0
            },
          },
          catalog: {
            required
          },
          attachment_id: {
            required
          }
        }
      },
      attachFiles: {
        $each: {
          expires_on: {
            required: requiredIf( function (data) {
              if(data.fileName && !data.expires_on){
                return _.some(this.form.items, (item) => item.attachment_id === data.attachment_id)
              }
              return false
            })
          }
        }
      },
      dynamicPlaceholders: {
        $each: {
          value: {
            required
          }
        }
      }
    }
  },
  methods: {
    setFormFromContract() {
      if (!this.contract)
        return

      this.form.number = this.contract.number
      this.form.date = Moment(this.contract.date, 'YYYY-MM-DD')
      this.form.title = this.contract.title
      this.form.place = this.contract.place
      this.form.expiresOn = Moment(this.contract.expires_on, 'YYYY-MM-DD')

      this.form.executor.id = this.contract.executor.id
      this.form.executor.inn = this.contract.executor.company_inn
      this.form.executor.name = this.contract.executor.company_name
      this.form.executor.directorInn = this.contract.executor.physic_inn
      this.form.executor.directorName = this.contract.executor.physic_name
      this.form.executor.phone = this.contract.executor.phone
      this.form.executor.mobile = this.contract.executor.mobile
      this.form.executor.address = this.contract.executor.address
      this.form.executor.bankAccount = this.contract.executor.bank_account
      this.form.executor.bankName = this.contract.executor.bank_name
      this.form.executor.bankMfo = this.contract.executor.bank_mfo

      this.form.customer.id = this.contract.customers[0].id
      this.form.customer.inn = this.contract.customers[0].company_inn
      this.form.customer.name = this.contract.customers[0].company_name
      this.form.customer.directorInn = this.contract.customers[0].physic_inn
      this.form.customer.directorName = this.contract.customers[0].physic_name
      this.form.customer.phone = this.contract.customers[0].phone
      this.form.customer.mobile = this.contract.customers[0].mobile
      this.form.customer.address = this.contract.customers[0].address
      this.form.customer.bankAccount = this.contract.customers[0].bank_account
      this.form.customer.bankName = this.contract.customers[0].bank_name
      this.form.customer.bankMfo = this.contract.customers[0].bank_mfo

      this.form.items = []
      for (let i = 0; i < this.contract.items.length; i++) {
        let item = this.addNewItem()
        item.id = this.contract.items[i].id
        item.product = this.contract.items[i].name
        item.barcode = this.contract.items[i].barcode
        item.measurement = this.contract.items[i].measurement
        item.quantity = this.contract.items[i].quantity
        item.price = this.contract.items[i].price
        item.ndsRate = this.contract.items[i].nds_rate
        item.defaultCatalogCode = this.contract.items[i].catalog_code
        item.attachment_id = this.contract.items[i].attachment_id
      }

      if (this.contract.dynamic_variables)
        this.form.dynamicPlaceholders = JSON.parse(this.contract.dynamic_variables)

      if (!this.contract.send_contract_approve_id) {
        this.form.parts = []
        for (let i = 0; i < this.contract.parts.length; i++) {
          this.form.parts.push({
            id: this.contract.parts[i].id,
            title: this.contract.parts[i].title,
            body: this.contract.parts[i].body,
            order: this.contract.parts[i].order
          })
        }
      }
      if (this.contract.files.length) {
        for (let i = 0; i < this.contract.files.length; i++) {
          this.form.attachFiles[i].id = this.contract.files[i].id
          this.form.attachFiles[i].attachment_id = this.contract.files[i].attachment_id
          this.form.attachFiles[i].expires_on = this.contract.files[i].expires_on ? Moment(this.contract.files[i].expires_on, 'YYYY-MM-DD') : null
          this.form.attachFiles[i].fileName = this.contract.files[i].filename
          this.form.attachFiles[i].file = {name: this.contract.files[i].filename}
          this.form.attachFiles[i].base64Content = this.contract.files[i].base_64_content
          this.addAttachFile()
        }
      }
    },
    loadDraftContract() {
      this.$store.dispatch(LAYOUT_LOADING_START)
      ContractService.getDraftContract(this.$route.params.id)
          .then(response => {
            this.contract = response.data

            if (this.contract.send_contract_approve_id)
              this.loadSentContractApprove(this.contract.send_contract_approve_id)
                  .then(() => {
                    this.setFormFromContract()
                  })
            else
              this.setFormFromContract()
          })
          .catch(() => {
            this.$router.go(-1)
          })
          .finally(() => {
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    loadCustomer() {
      ContractService.getCompany(this.form.customer.inn)
          .then(response => {
            this.form.customer.inn = response.data.inn
            this.form.customer.name = response.data.name
            this.form.customer.bankAccount = response.data.bank_account
            this.form.customer.bankMfo = response.data.bank_mfo
            this.form.customer.bankName = response.data.bank_name
            this.form.customer.address = response.data.address

            if (response.data.director_inn || response.data.director_pinfl) {
              this.form.customer.directorInn = response.data.director_inn || response.data.director_pinfl
              if (!(this.sendContractApprove && this.sendContractApprove.customer_director)) {
                this.form.customer.directorName = response.data.director || response.data.name
              }
            } else {
              this.form.customer.directorInn = response.data.inn
              if (!(this.sendContractApprove && this.sendContractApprove.customer_director))
                this.form.customer.directorName = response.data.name
            }
          })
    },
    loadSentContractApprove(id) {
      return new Promise((resolve, reject) => {
        this.$store.dispatch(LAYOUT_LOADING_START)
        SendContractApproveService.getOneByExecutor(id)
            .then(response => {
              this.sendContractApprove = response.data
              this.onSendContractApproveLoaded()
              resolve()
            })
            .catch(() => {
              reject()
            })
            .finally(() => {
              this.$store.dispatch(LAYOUT_LOADING_STOP)

            })
      })
    },
    removePart(part) {
      const index = this.form.parts.indexOf(part)
      if (index > -1) {
        const removingOrder = part.order
        this.form.parts.splice(index, 1)
        _.each(this.form.parts, part => {
          if (part.order > removingOrder) {
            part.order--
          }
        })
      }
    },
    addPartAfter(part) {
      const currentIndex = this.form.parts.indexOf(part)
      const currentOrder = part.order

      _.each(this.form.parts, part => {
        if (part.order > currentOrder) {
          part.order++
        }
      })

      this.form.parts.splice(currentIndex + 1, 0, {
        id: 0,
        title: '',
        body: '',
        order: currentOrder + 1
      },)
    },
    fetchDynamicPlaceholders(input) {
      const splitterRegex = /{{[a-zA-Z0-9.]+}}/g

      let matches = [...input.matchAll(splitterRegex)]
      _.each(matches, match => {
        // get key by trim {{ and }} symbols
        //const key = match[0].substr(2, match[0].length - 4)
        const key = match[0]

        // check for key exists
        const keyExists = _.filter(this.form.dynamicPlaceholders, dynamicPlaceholder => {
          return dynamicPlaceholder.key === key
        }).length !== 0
        if (!keyExists) {
          let placeholder = {
            key: key,
            value: ''
          }
          if (placeholder.key === specialDynamicPlaceholders.contractBasedOn)
            placeholder.value = 'Устава'

          this.form.dynamicPlaceholders.push(placeholder)
        }
      })
    },
    applyDynamicPlaceholders(input) {
      _.each(this.form.dynamicPlaceholders, dynamicPlaceholder => {
        input = input.replace(dynamicPlaceholder.key, dynamicPlaceholder.value)
      })

      return input
    },
    isHiddenDynamicPlaceholder(dp) {
      return dp.key === specialDynamicPlaceholders.contractExpireDate ||
          dp.key === specialDynamicPlaceholders.contractTotalCost ||
          dp.key === specialDynamicPlaceholders.executorCompanyName ||
          dp.key === specialDynamicPlaceholders.executorDirector ||
          dp.key === specialDynamicPlaceholders.contractDate ||
          dp.key === specialDynamicPlaceholders.contractNumber;
    },
    loadProductCatalogs() {
      CompanyService.getCompanyCatalogCodesInfo()
          .then(response => {
            this.productCatalogs = response.data
          })
    },

    save() {
      this.$store.dispatch(LAYOUT_LOADING_START)

      ContractService.saveDraftContract(this.contract.id, this.sendContractApprove ? this.sendContractApprove.id : null, {
        title: this.form.title,
        number: this.form.number,
        date: this.form.date.format('YYYY-MM-DD'),
        place: this.form.place,
        expires_on: this.form.expiresOn.format('YYYY-MM-DD'),
        total_in_words: this.totals.totalWithNdsInWords,
        executor: {
          id: this.form.executor.id,
          company_inn: this.form.executor.inn,
          company_name: this.form.executor.name,
          physic_inn: this.form.executor.directorInn,
          physic_name: this.form.executor.directorName,
          phone: this.form.executor.phone,
          mobile: this.form.executor.mobile,
          address: this.form.executor.address,
          bank_account: this.form.executor.bankAccount,
          bank_mfo: this.form.executor.bankMfo,
          bank_name: this.form.executor.bankName,
        },
        customers: [{
          id: this.form.customer.id,  
          company_inn: this.form.customer.inn,
          company_name: this.form.customer.name,
          physic_inn: this.form.customer.directorInn,
          physic_name: this.form.customer.directorName,
          phone: this.form.customer.phone,
          mobile: this.form.customer.mobile,
          address: this.form.customer.address,
          bank_account: this.form.customer.bankAccount,
          bank_mfo: this.form.customer.bankMfo,
          bank_name: this.form.customer.bankName,
        }],
        parts: _.map(this.form.parts, part => {
          return {
            id: part.id,
            title: part.title,
            body: part.body,
            order: part.order
          }
        }),
        items: _.map(this.form.items, item => {
          return {
            id: item.id,
            name: item.product,
            barcode: item.barcode,
            measurement: item.measurement,
            quantity: parseFloat(item.quantity),
            price: parseFloat(item.price),
            total: this.getItemTotal(item),
            nds_rate: item.ndsRate,
            nds_value: item.ndsRate !== null ? this.getItemNdsValue(item) : null,
            attachment_id: item.attachment_id === 0 ? null : item.attachment_id,
            total_with_nds: this.getItemTotalWithNds(item),
            catalog_code: item.catalog.classCode,
            catalog_name: item.catalog.name
          }
        }),
        files: _.filter(this.form.attachFiles, af => {
          return af.file !== null
        }).map(af => {
          return {
            id: af.id,
            filename: af.fileName,
            attachment_id: af.attachment_id === 0 ? null : af.attachment_id,
            expires_on: af.expires_on ? af.expires_on.format('YYYY-MM-DD') : af.expires_on,
            base_64_content: af.base64Content
          }
        }),
        dynamic_variables: JSON.stringify(this.form.dynamicPlaceholders),
        agreement_type: this.sendContractApprove && typeof (this.sendContractApprove.agreement_type) === 'number' ? this.sendContractApprove.agreement_type : null,
      })
          .then(response => {
            this.$router.push({name: 'view-contract', params: {id: response.data.id}})
          })
          .finally(() => {
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },

    // ui
    onCustomerCompanyChanged() {
      if (this.form.customer.company) {
        this.form.customer.inn = this.form.customer.company.inn
        this.form.customer.name = this.form.customer.company.name

        this.form.customer.dialog = false
        this.loadCustomer()
      }
    },
    onRemovePartButtonClicked(part) {
      this.removePart(part)
    },
    onAddPartAfterButtonClicked(part) {
      this.addPartAfter(part)
    },
    onSaveButtonClicked() {
      this.$v.form.$touch()
      if (!this.$v.form.$invalid) {
        this.save()
      }
    },
    onAddItemButtonClicked() {
      this.addNewItem()
    },
    onDeleteItemButtonClicked(item) {
      const index = this.form.items.indexOf(item)
      if (index > -1) {
        this.form.items.splice(index, 1)
      }
    },
    onAttachFileChanged(attachFile) {
      if (attachFile.file) {
        attachFile.attachment_id = (new Date()).getTime()
        attachFile.fileName || this.addAttachFile()
        attachFile.fileName = attachFile.file.name
        const reader = new FileReader();
        reader.onload = function (e) {
          attachFile.base64Content = e.target.result.split(',')[1];
        };

        reader.readAsDataURL(attachFile.file);
      } else {
        const index = this.form.attachFiles.indexOf(attachFile)
        if (index > -1) {
          this.form.attachFiles.splice(index, 1)
          if (this.form.attachFiles.filter(af => af.file === null).length === 0)
            this.addAttachFile()
        }
      }
    },
    onImportFromFileButtonClicked() {
      this.excelFile.dialog = false
      if (this.excelFile.file) {
        let reader = new FileReader()
        reader.onload = (e) => {
          const base64Content = e.target.result.split(',')[1];
          ParseService.parse(base64Content)
              .then(response => {
                try {
                  if (response.data[0].Data.length > 0) {
                    while (this.form.items.length > 0)
                      this.form.items.shift()

                    const productIndex = 1
                    const catalogCodeIndex = 2
                    const barcodeIndex = 3
                    const measurementIndex = 4
                    const quantityIndex = 5
                    const priceIndex = 6
                    const ndsRateIndex = 8


                    this.$nextTick(() => {
                      for (let rowIndex = 9; rowIndex < response.data[0].Data.length; rowIndex++) {
                        const row = response.data[0].Data[rowIndex]
                        let ndsRateString = ""
                        let quantityString = ""
                        let priceString = ""
                        if(row[ndsRateIndex] !== undefined && row[ndsRateIndex] !== null) ndsRateString = row[ndsRateIndex].toString().trim().replace(/[^\d]/g, '')
                        if(row[quantityIndex] !== undefined && row[quantityIndex] !== null) quantityString = row[quantityIndex].toString().replace(/[.]/g, ",").replace(/,([^,]+)$/, '.$1').replace(/[^\d.]/g, '')
                        if(row[priceIndex] !== undefined && row[priceIndex] !== null) priceString = row[priceIndex].toString().replace(/[.]/g, ",").replace(/,([^,]+)$/, '.$1').replace(/[^\d.]/g, '')

                        let ndsRate = null
                        switch (ndsRateString) {
                          case '':
                            ndsRate = null
                            break
                          case '0':
                            ndsRate = 0
                            break
                          case '15':
                            ndsRate = 15
                            break
                          default:
                            ndsRate = null
                        }
                        let item = this.addNewItem()

                        if(row[productIndex] !== undefined && row[productIndex] !== null) item.product = row[productIndex].toString()
                        if(row[barcodeIndex] !== undefined && row[barcodeIndex] !== null) item.barcode = row[barcodeIndex].toString()
                        if(row[measurementIndex] !== undefined && row[measurementIndex] !== null) item.measurement = row[measurementIndex].toString()
                        item.quantity = ItemCalculator.getDecimalWithTwoDigit(quantityString)
                        item.price = ItemCalculator.getDecimalWithTwoDigit(priceString)
                        item.ndsRate = ItemCalculator.getDecimalWithTwoDigit(ndsRate)
                        if(row[catalogCodeIndex] !== undefined && row[catalogCodeIndex] !== null) item.defaultCatalogCode = row[catalogCodeIndex].toString().trim()
                      }
                    })
                  }
                } catch (e) {
                  window.console.log(e)
                }
              })
        }
        reader.readAsDataURL(this.excelFile.file);
      }
    },
    onItemMxikSelected(item, catalog) {
      item.catalog = catalog
    },

    // events
    onSendContractApproveLoaded() {
      this.form.dynamicPlaceholders = []

      if (this.sendContractApprove.parts.length > 0) {
        this.form.parts = this.sendContractApprove.parts.map(p => {
          this.fetchDynamicPlaceholders(p.title)
          this.fetchDynamicPlaceholders(p.content)

          return {
            title: p.title,
            body: p.content,
            order: p.order
          }
        })
      }

      this.onDynamicPlaceholderInput()
    },
    onDynamicPlaceholderInput() {
      if (this.sendContractApprove) {
        this.form.parts = this.sendContractApprove.parts.map(p => {
          this.fetchDynamicPlaceholders(p.title)
          this.fetchDynamicPlaceholders(p.content)

          return {
            title: this.applyDynamicPlaceholders(p.title),
            body: this.applyDynamicPlaceholders(p.content),
            order: p.order
          }
        })
      }
    },

    getItemTotal(item) {
      return ItemCalculator.getTotal(item.quantity, item.price)
    },
    getItemNdsValue(item) {
      return ItemCalculator.getNdsValue(item.quantity, item.price, item.ndsRate || 0)
    },
    getItemTotalWithNds(item) {
      return ItemCalculator.getTotalWithNds(item.quantity, item.price, item.ndsRate || 0)
    },
    addAttachFile() {
      let file = {
        id: 0,
        attachment_id: null,
        expires_on: null,
        fileName: '',
        file: null,
        base64Content: null
      }
      this.form.attachFiles.push(file);
      return file
    },
    addNewItem() {
      let item = {
        id: 0,
        product: '',
        barcode: '',
        measurement: '',
        quantity: 0,
        price: 0,
        ndsRate: null,
        catalog: null,
        defaultCatalogCode: null,
        attachment_id: null
      }
      this.form.items.push(item)
      return item
    }
  },
  created() {
    this.loadDraftContract()
    this.addAttachFile();
    this.loadProductCatalogs();
  },
  watch: {
    "form.items": {
      deep: true,
      handler() {
        let placeholder = this.form.dynamicPlaceholders.find(x => {
          return x.key === specialDynamicPlaceholders.contractTotalCost
        })
        if (placeholder) {
          placeholder.value = this.totals.totalWithNdsInWords
          this.onDynamicPlaceholderInput()
        }

      }
    },
    "form.date"() {
      let placeholder = this.form.dynamicPlaceholders.find(x => {
        return x.key === specialDynamicPlaceholders.contractDate
      })
      if (placeholder) {
        let value = ''
        if (this.form.date)
          value = this.form.date.locale('ru').format('D MMMM YYYY')

        placeholder.value = value

        this.onDynamicPlaceholderInput()
      }
    },
    "form.number"() {
      let placeholder = this.form.dynamicPlaceholders.find(x => {
        return x.key === specialDynamicPlaceholders.contractNumber
      })
      if (placeholder) {
        placeholder.value = this.form.number
        this.onDynamicPlaceholderInput()
      }
    },
    "form.expiresOn": {
      handler() {
        let placeholder = this.form.dynamicPlaceholders.find(x => {
          return x.key === specialDynamicPlaceholders.contractExpireDate
        })
        if (placeholder) {
          let value = ''
          if (this.form.expiresOn)
            value = this.form.expiresOn.locale('ru').format('D MMMM YYYY')

          placeholder.value = value

          this.onDynamicPlaceholderInput()
        }
      }
    },
    "form.customer.directorName"() {
      let placeholder = this.form.dynamicPlaceholders.find(x => {
        return x.key === specialDynamicPlaceholders.executorDirector
      })
      if (placeholder) {
        placeholder.value = this.form.customer.directorName
        this.onDynamicPlaceholderInput()
      }
    },
    "form.customer.name"() {
      let placeholder = this.form.dynamicPlaceholders.find(x => {
        return x.key === specialDynamicPlaceholders.executorCompanyName
      })
      if (placeholder) {
        placeholder.value = this.form.customer.name
        this.onDynamicPlaceholderInput()
      }
    }
  }
}
</script>